import "core-js/modules/es6.object.to-string";
export default function isFunction(functionToCheck) {
  var getType = {};
  return !!functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}